/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable, Injector} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';
import {Observable} from 'rxjs';
import {AuthenticationService} from './authentication.service';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private injector: Injector, private readonly authenticationService: AuthenticationService , private oauthService: OAuthService
  ) {
  }

  /**
   * Interecepts all outbound HTTP requests and adds the authorization token to the header
   * @param request - the outgoing request object
   * @param next - the next interceptor or the api if no more interceptors in the chain
   * @return an observable of the event stream, or an error if the request returned one
   */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {


    // changing the auth intercepotr in the app.module
    const token = this.oauthService.getAccessToken();
    if (token === null) {
      // If there's no token, just forward the request without modifying it
      return next.handle(request);
    } else {
      const authReq = request.clone({setHeaders: {Authorization: `Bearer ${token}`}});
      return next.handle(authReq);
    }



  }
}
